import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './tab-nav.styles'
import TabLink from './tab-link/tab-link'
import { useSubscriptionPolicy } from 'pobble-components/dist/subscriptions'
import { SubsCrown } from 'pobble-components/dist/subscriptions'
import { useMe } from 'pobble-components/dist/pobble-user'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import { UpsellModal } from '../../../upsell/upsell'

const TabNav = ({
  classes,
  activeTab,
  changeActiveTab,
  currentCounter,
  canManageAFs,
  canSeeTrainingFiles
}) => {
  const examplificationSp = useSubscriptionPolicy(
    sp => sp.moderation.examplification_material
  )
  const { me, showSchoolRequiredDialog } = useMe()
  const hasSchool = me.account.policy.teacher_in_school
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)

  return (
    <div className={classes.holder}>
      <div className={classes.container}>
        <div className={classes.current}>
          <TabLink to="/invitations">Invitations</TabLink>
          {!!currentCounter && (
            <span className={classes.currentCounter}>{currentCounter}</span>
          )}
        </div>
        <TabLink
          to="/my-files"
          onClick={e => {
            if (!hasSchool) {
              e.preventDefault()
              showSchoolRequiredDialog()
            }
          }}>
          My files
        </TabLink>
        <TabLink
          to="/school"
          onClick={e => {
            if (examplificationSp.restricted) {
              e.preventDefault()
              setUpsellModalOpen(true)
            } else if (!hasSchool) {
              e.preventDefault()
              showSchoolRequiredDialog()
            }
          }}>
          {examplificationSp.restricted && <SubsCrown />} School files
        </TabLink>
        <TabLink to="/writing-samples">Writing samples</TabLink>
        {canSeeTrainingFiles && (
          <TabLink to="/trainings">Training files</TabLink>
        )}
        {/*canManageAFs && <TabLink to="/local-authority">Local authority</TabLink>*/}
        <TabLink to="/support">
          <FontAwesomeIcon
            className={classes.howIcon}
            icon={faQuestionCircle}
          />
          How to use
        </TabLink>
      </div>
      <UpsellModal
        id="assesment-file"
        isOpen={upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </div>
  )
}

export default injectSheet(styles)(TabNav)
